








import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'

import { SearchMode } from '@/composables/use-search-mode'
import useI18n from '@/composables/use-i18n'

export default defineComponent({
  props: {
    offset: {
      type: Number,
      default: 0,
    },
    mode: {
      type: String as PropType<SearchMode | null>,
      default: null,
    },
  },
  setup (props, { emit }) {
    const containerStyle = computed(() => ({
      bottom: `${props.offset}px`,
    }))

    const i18n = useI18n()
    const text = computed(() => props.mode
      ? {
          map: i18n.t('search.mode.list'),
          list: i18n.t('search.mode.map'),
        }[props.mode]
      : null
    )

    const setList = () => emit('set', 'list' as SearchMode)
    const setMap = () => emit('set', 'map' as SearchMode)

    const click = () => (props.mode
      ? {
          map: setList,
          list: setMap,
        }[props.mode]
      : () => {})()

    return {
      containerStyle,
      text,
      click,
    }
  },
})
